import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { AppHeader } from "../../../components/organisms";
import { OrderDetailsComp } from "./Detail/OrderDetailsComp";
import { useSelector, useDispatch } from "react-redux";
import { notificationSchedulerTime, AnalyticsService, getNotifications } from "../../../utils";

const OrderDetaisDelivery = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const numOfNewOrders = useSelector(state => state.notifications.numOfNewOrders);
    const onBack = () => {
        navigate("/dashboard");
    };
    const Signout = () => {
        navigate("/");
        const userEmail = localStorage.getItem("userEmail");
        AnalyticsService.logEvent("USER_LOGGED_OUT", {
            userEmail: userEmail
        });
        AnalyticsService.identifyUser(null);
        AnalyticsService.clearUserProperties();
        localStorage.clear();
        localStorage.setItem("isAuthenticated", false);
        AnalyticsService.logEvent('USER_LOGGED_OUT_SUCCESSFULLY');
    };

    useEffect(() => {
        const interval = setInterval(() => getNotifications(numOfNewOrders, dispatch, navigate), notificationSchedulerTime);

        return () => clearInterval(interval);
    }, [numOfNewOrders])

    return (
        <div className="dashboardSec" id="custom-top">
            <AppHeader Signout={Signout} />
            <div className="dashboard-container">
                <OrderDetailsComp onBack={onBack} />
            </div>
        </div>
    );
};
export default OrderDetaisDelivery;
